const features = [
  '5G support',
  'Wi-Fi',
  // 'Bluetooth', TODO
  'HDR support',
  'Always-on display (AOD)',
  'Mute switch',
  'Refresh rate',
  'Speakers',
  'IP rating',
  'Curved display',
  'Curved or rounded back',
  'Headphone jack',
  'Storage type',
  'Expandable storage',
  'Dual SIM',
  'Face unlock',
  'Fingerprint sensor',
  'Wireless charging',
  'Reverse wireless charging',
  'Multitask split-screen',
  'Updates',
  'AI',
  'Assistant',
];

export default features;
